export const addLogo = () => {
  const jobTiles = document.querySelectorAll(".attrax-vacancy-tile");

  if (!jobTiles) {
    return;
  }

  jobTiles.forEach((jobTile) => {
    let logoWrapper = document.createElement("div");
    logoWrapper.classList.add("attrax-vacancy-tile__logo-wrapper");
    logoWrapper.classList.add("attrax-vacancy-tile__item");
    const image = document.createElement("img");
    image.src = "/Blob/images/logos/logo.webp";
    image.classList.add("attrax-vacancy-tile__logo");
    image.loading = "lazy";
    image.width = 127;
    image.height = 94;
    image.alt = "Rexel Logo";
    logoWrapper.appendChild(image);
    jobTile.prepend(logoWrapper);
  });
};

export const logoReplacer = () => {
  const jobOptionClass: string = ".attrax-vacancy-tile--";

  //the options given should be the same name give to logos placed in the logo folder including the file extension
  const optionArray: { brand: string; fileType: string }[] = [
    { brand: "rexel", fileType: "webp" },
    { brand: "espace-elec", fileType: "webp" },
    { brand: "esabora", fileType: "webp" },
    { brand: "cordia", fileType: "webp" },
    { brand: "itesa", fileType: "webp" },
    { brand: "francofa-eurodis", fileType: "webp" },
    { brand: "freshmile", fileType: "webp" },
    { brand: "mavisun", fileType: "webp" },
    { brand: "sofinther", fileType: "webp" },
    { brand: "rexel-dev", fileType: "webp" },
    { brand: "bizline", fileType: "webp" },
    { brand: "gigamedia", fileType: "webp" },
    { brand: "elektromaterial-ag", fileType: "webp" },
    { brand: "gexpro", fileType: "webp" },
    { brand: "mayer", fileType: "webp" },
    { brand: "platt", fileType: "webp" },
    { brand: "talley", fileType: "webp" },
    { brand: "parts-super-center", fileType: "webp" },
    { brand: "capitol-light", fileType: "webp" },
    { brand: "wasco", fileType: "webp" },
    { brand: "ideal-electrical-suppliers", fileType: "webp" },
    { brand: "john-r-turk", fileType: "webp" },
    { brand: "learsmith", fileType: "webp" },
    { brand: "nedco", fileType: "webp" },
    { brand: "westburne", fileType: "webp" },
    { brand: "rexel-atlantic", fileType: "webp" },
    { brand: "utility", fileType: "webp" },
    { brand: "beijing-zhongheng", fileType: "webp" },
    { brand: "rexel-electric", fileType: "webp" },
    { brand: "rexel-intelligent-control", fileType: "webp" },
    { brand: "ouneng", fileType: "webp" },
    { brand: "suzhou-xidian", fileType: "webp" },
    { brand: "huazhang-automation", fileType: "webp" },
    { brand: "zhonghao-technology", fileType: "webp" },
    { brand: "rexel-industrial-supply-solutions", fileType: "webp" },
    { brand: "rexel-industrial-solutions", fileType: "webp" },
    { brand: "kellihers", fileType: "webp" },
    { brand: "denmans", fileType: "webp" },
    { brand: "ltl", fileType: "webp" },
    { brand: "orka", fileType: "webp" },
    { brand: "rexel-s", fileType: "webp" },
    { brand: "connectronics", fileType: "webp" },
    { brand: "schwing-electrical-supply", fileType: "webp" },
    { brand: "warshauer", fileType: "webp" },
    { brand: "rexel-nl-wasco", fileType: "png" },
  ];

  optionArray.forEach((option) => {
    const className = jobOptionClass + option.brand;

    if (document.getElementsByClassName(className)) {
      const filePath = `/Blob/images/logos/${option.brand}.${option.fileType}`;

      const foundClass: Element[] = Array.from(
        document.querySelectorAll(className)
      );

      foundClass.forEach((brandoption) => {
        const parentTile = brandoption.closest<HTMLElement>(
          ".attrax-vacancy-tile"
        );
        const logowrapper = parentTile?.querySelector<HTMLElement>(
          ".attrax-vacancy-tile__logo-wrapper"
        );
        const logo = parentTile?.querySelector<HTMLImageElement>(
          ".attrax-vacancy-tile__logo"
        );

        if (!logo || !logowrapper) {
          return;
        }

        logo.src = filePath;
        logo.alt = `${option.brand} logo`;
        logo.classList.add("attrax-vacancy-tile__logo--" + option.brand);
        logowrapper.classList.add(
          "attrax-vacancy-tile__logo-wrapper--replaced"
        );
      });
    }
  });
};

export const brandClassAssignment = () => {
  const brandtiles = document.querySelectorAll(
    ".attrax-vacancy-tile__option-brand"
  );

  if (!brandtiles) {
    return;
  }

  brandtiles.forEach((brandtile) => {
    const brandclass = [...brandtile.classList].find((el) =>
      el.includes("attrax-vacancy-tile__option-brand--")
    );

    if (!brandclass) {
      return;
    }

    brandtile.closest(".attrax-vacancy-tile")?.classList.add(brandclass);
  });
};


export const putJobOptionsIntoContainer = () => {
  const jobtiles = document.querySelectorAll<HTMLDivElement>(".attrax-vacancy-tile");

  jobtiles.forEach((jobtile) => {
    const JobOptionContainer = document.createElement("div");
    JobOptionContainer.classList.add("attrax-vacancy-tile__option-container");
    const jobOptions = jobtile.querySelectorAll<HTMLElement>(
      `.attrax-vacancy-tile__location-freetext, 
      .attrax-vacancy-tile__option-brands, 
      .attrax-vacancy-tile__option-location, 
      .attrax-vacancy-tile__option-job-type,
      .attrax-vacancy-tile__option-experience-level, 
      .attrax-vacancy-tile__option-job-family`
    );

    jobOptions.forEach((jobOption) => {
      JobOptionContainer.appendChild(jobOption);
    });

    jobtile.appendChild(JobOptionContainer);
  });
}

export const setActive = () => {
  const jobtiles = document.querySelectorAll(".attrax-vacancy-tile");

  if (!jobtiles) {
    return;
  }

  jobtiles.forEach((jobtile) => {
    jobtile.classList.add("attrax-vacancy-tile--active");
  });
};
